module.exports = __webpack_public_path__ + "static/img/cover1.3f590170.jpg";